<image-to-right [imgURL]="'assets/images/pills_mockup.jpeg'" [topLogo]="false" [bottomLogo]="false"
  [content]="this.thanksTemplate">
</image-to-right>

<ng-template #thanksTemplate>
  <div class="thanks__header container">
    <div class="thanks__header--logo">
      <img src="{{this.environment.assets.logo}}" alt="">
    </div>
    <div class="thanks__header--loginLink mt-5 mt-lg-0">
      <a [routerLink]="'/login/.'" i18n>Ir al login</a>
    </div>
  </div>
  <div class="thanks__body">
    <div class="thanks__body--title" i18n>
      <h2 class="text-uppercasa text-center">¡MUCHAS GRACIAS!</h2>
      <p class="text-center p-0 m-0">Hemos recibido con éxito tu formulario. Inicia sesión ahora para continuar con tu
        tratamiento.</p>
      <div class="title__image">
        <img src="assets/images/fungi_inside_out.svg" alt="" srcset="">
      </div>
    </div>
    <div class="thanks__body--video_zone">
      <div class="title">
        <!-- <h3 class="text-justify text-uppercase">Mientras te dejamos algunos videos e información sobre lo que hacemos</h3> -->
        <!-- <p class="m-0 p-0 text-center">Estos videos muestran mas sobre la MD</p> -->
      </div>
      <!-- <div class="videos">
                <div class="video__container">video</div>
                <div class="video__container">video</div>
            </div> -->
    </div>
  </div>
  <!-- <div class="faqs">
        <app-faqs 
        [sliceItems]="4"
        [scheduleOption]="false"
        ></app-faqs>
    </div> -->

</ng-template>